module.exports = __webpack_public_path__ + "img/waiter.3b00fef2.svg";